export default defineAppConfig({
    clarity: 'qxeckl8z0w',
    ui: {
        primary: 'neutral',
        gray: 'neutral',
        strategy: 'merge',
        notification: {
            background: 'bg-{color}-100 notification-{color}',
            title: 'title',
            description: 'leading-normal',
            ring: 'ring-notification',
        },
        formGroup: {
            label: {
                base: 'text-neutral-900',
                required: "after:text-neutral-900",
            },
        }
    },
    stripe: {
        empty:{
            color: '#11142D',
            fontWeight: '500',
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            backgroundColor: '#ffffff',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
                color: '#11142D',
            },
            '::placeholder': {
                color: '#D1D4E0',
            },
        }
    }
})
